import React, { useState, useEffect } from "react";
import { getChurchUsersAction } from "../../store/Users/UsersAction";
import { useDispatch } from "react-redux";
import UserIcon from "../../assets/icons/user.png";
import CustomTable from "../../components/universal/CustomTable";
import UserInsightModal from "../../components/users/UserInsightModal";
import "react-confirm-alert/src/react-confirm-alert.css";

const BubbleComponent = ({ church }) => {
  const dispatch = useDispatch();

  const [reloadData, setReloadData] = useState(false);
  const [searchValue] = useState("");
  const [selectedUser, setSelectedUser] = useState(null);

  /* ---------------- Table Headers Configuration ---------------- */
  const allUserHeader = [
    {
      headerName: "First Name",
      headerId: "firstName",
    },
    {
      headerName: "Last Name",
      headerId: "lastName",
    },
    {
      headerName: "TWG ID",
      headerId: "twgId",
    },
    {
      headerName: "Preference",
      headerId: "preference", // New column for preferences
    },
  ];

  /* ---------------- Function to get preference text ---------------- */
  const getPreferenceText = (user) => {
    const preferences = [];

    if (user?.isHomeChurch === true) {
      preferences.push("Home Church");
    }

    if (user?.isLikedChurch === true) {
      preferences.push("Favourite Church");
    }

    if (preferences.length === 0) {
      return "No Preference";
    }

    return preferences.join(", ");
  };

  /* ---------------- Fetch Church Users Function ---------------- */
  const fetchChurchUsers = (page, limit, searchCriteria = {}, callbackFn) => {
    // Ensure church object has _id
    const churchObjId = church?._id;

    if (!churchObjId) {
            if (callbackFn) {
        callbackFn({
          data: [],
          total: 0,
          pageNum: page,
        });
      }
      return;
    }


    dispatch(
      getChurchUsersAction({
        churchObjId: churchObjId,
        page: page || 1,
        limit: limit || 10,
        search: searchCriteria.search || "",
        callback: (response) => {

          if (response?.type === 1) {
            const churchUsers = response?.data || [];

            if (churchUsers.length > 0) {
                                                      }

            // Transform the data to match your table structure
            const normalizedData = churchUsers.map((user, index) => {
              const preferenceText = getPreferenceText(user);

              return {
                ...user,
                // Use the fields directly from response
                firstName: user?.firstName || user?.firstname || "Unknown",
                lastName: user?.lastName || user?.lastname || "",
                email: user?.email || user?.mail || "No email",
                mobile: user?.mobile || user?.phone || "No phone",
                profilePic: user?.profilePicUrl || user?.profileImage || UserIcon,
                twgId: user?.twgId || `USER_${index}`,
                bio: user?.aboutMe || user?.bio || "",
                preference: preferenceText, // Add preference field
                isHomeChurch: user?.isHomeChurch || false, // Keep original values
                isLikedChurch: user?.isLikedChurch || false, // Keep original values
              };
            });


            if (normalizedData.length > 0) {
                                                      }

            if (callbackFn) {
              callbackFn({
                data: normalizedData,
                total: response?.totalCount || churchUsers.length || 0,
                pageNum: page,
              });
            }
          } else {
                        if (callbackFn) {
              callbackFn({
                data: [],
                total: 0,
                pageNum: page,
              });
            }
          }
        },
      })
    );
  };

  // Add this useEffect to trigger reload when church changes
  useEffect(() => {
    if (church?._id) {
            setReloadData(prev => !prev);
    }
  }, [church?._id]);

  //function to open selected follower details
  const handleUserInsightOpen = (row) => {
    setSelectedUser(row);
  };

  //function to close selected follower details
  const handleUserInsightClose = () => {
    setSelectedUser(null);
  };

  return (
    <>
    {
      church?
    <div>
      <div className="px-4">
        <div className="flex flex-col gap-4 relative">
          <CustomTable
            searchFor="Church Users"
            heightDesktop="h-[65vh]"
            width=""
            nthChildWidth="[&>*:nth-child(1)]:w-[150px] [&>*:nth-child(2)]:w-[150px] [&>*:nth-child(3)]:w-[150px] [&>*:nth-child(4)]:w-[200px]"
            notificationTable={true}
            data={[]}
            headers={allUserHeader}
            customDataFetch={true}
            customDataFetchFunction={fetchChurchUsers}
            reloadData={reloadData}
            setReloadData={setReloadData}
            reverseTable={true}
            nthChildStyle=""
            searchCriteria={{ search: searchValue }}
            handleEyeClick={handleUserInsightOpen}
            onDataLoaded={(data) => undefined}
          />
          <UserInsightModal
            isOpen={Boolean(selectedUser)}
            onClose={handleUserInsightClose}
            user={selectedUser}
            entityName={church?.churchName || "this church"}
          />
        </div>
      </div>
    </div>
    :
    <div className="w-full h-full flex items-center justify-center text-gray-400 ">
       <p>Add Church/Ministry/Channel First</p>

    </div>
}
    </>
  );
};

export default BubbleComponent;
